/* pdp-trust.js – Besitzer: Agent «Vertrauen» (siehe PDP-ELITE-SPEC.md)
   Leerzustand der Bewertungen: Der Button «Erste Bewertung schreiben» klickt das echte «Bewertung schreiben» des
   Judge.me-Widgets (das im DOM bleibt, aber eingeklappt ist). Erscheinen unerwartet doch Bewertungen oder lädt das
   Widget nicht, wird es aufgeklappt, damit nichts verloren geht. Judge.me selbst wird nicht verändert. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp-rv]');
  if (!root || root.getAttribute('data-rv-state') !== 'empty') return;
  var apps = root.querySelector('[data-rv-apps]');
  var cta = root.querySelector('[data-rv-write]');
  if (!apps || !cta) return;

  var SEL_WRITE = '[data-testid="write-review-button"], .jm-action-buttons__button, .jdgm-write-rev-link, .jdgm-write-rev-link__btn';
  var SEL_REVIEWS = '.jm-review-item, .jdgm-rev';
  var observer = null;
  var timer = null;

  function open() { root.classList.add('is-open'); }
  function stop() {
    if (observer) { observer.disconnect(); observer = null; }
    if (timer) { clearTimeout(timer); timer = null; }
    cta.removeAttribute('aria-busy');
  }
  function findWrite() { return apps.querySelector(SEL_WRITE); }

  // Echte Bewertungen aufgetaucht (z. B. Metafeld noch nicht aktuell): Widget zeigen.
  var watcher = new MutationObserver(function () {
    if (apps.querySelector(SEL_REVIEWS)) { open(); watcher.disconnect(); }
  });
  watcher.observe(apps, { childList: true, subtree: true });
  if (apps.querySelector(SEL_REVIEWS)) { open(); watcher.disconnect(); }

  cta.addEventListener('click', function () {
    var btn = findWrite();
    if (btn) { btn.click(); return; }
    // Widget lädt noch: kurz warten, dann klicken; sonst Widget aufklappen.
    if (observer) return;
    cta.setAttribute('aria-busy', 'true');
    observer = new MutationObserver(function () {
      var b = findWrite();
      if (b) { stop(); b.click(); }
    });
    observer.observe(apps, { childList: true, subtree: true });
    timer = setTimeout(function () { stop(); open(); }, 8000);
  });
})();
